import PartnerBalanceInfo from 'components/PartnerBalanceInfo'
import PartnerInfoCard from '../components/PartnerInfoCard'
import React from 'react'
import { useWallet } from 'contexts/WalletContext'

const PartnerDetailPage = () => {
    const { wallet } = useWallet()

    return (
        <>
            <div className="bg-[#F3F4F6] h-screen">
                <p className="font-semibold mx-8 my-4 text-[20px]">Partner Details</p>

                <div className="bg-white mx-8 my-4 p-4 rounded-md shadow-sm">
                    <PartnerInfoCard />
                    {/* ✅ Only render once walletId is set */}
                    {wallet?.anchorWalletId ? (
                        <PartnerBalanceInfo walletId={wallet.anchorWalletId} />
                    ) : (
                        <p className="mx-8 my-4 text-gray-500">Loading wallet info...</p>
                    )}
                </div>
            </div>
        </>
    )
}

export default PartnerDetailPage
